import React, { useContext } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'
import { newCitySchema } from '../../../util/validationSchema'
import { yupResolver } from '@hookform/resolvers/yup'
import { SpinnerContext } from '../../../context/spinnerContext'
import { errorToast, successToast } from '../../../util/Toast/toast'
import { addCity } from '../../../redux/slices/citySlice'

const NewCity = ({ toggle, setIsRefresh, regionID }) => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)
  const { allRegion } = useSelector(({ region }) => region)

  // Find the region based on regionID
  const defaultRegion = regionID ? allRegion.find((region) => region.region_id === regionID) : null

  const {
    handleSubmit,
    control,
    trigger,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(newCitySchema),
    defaultValues: {
      region: defaultRegion ? { region_id: defaultRegion.region_id, region: defaultRegion.region } : null
    }
  })

  const onSubmit = (data) => {
    setIsRefresh(false)
    const payload = {
      ...data,
      region: data?.region?.region_id
    }
    dispatch(addCity(payload))
      .then(({ payload, error }) => {
        if (payload?.status === 200) {
          toggle()
          changeLoader(false)
          setIsRefresh(true)
          successToast(payload?.data?.status_message || 'Success!')
        } else {
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
      .catch(() => {
        changeLoader(false)
      })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className="col-lg-12 col-sm-12">
          <div className="form-group">
            <label>
              Country <span className="text-danger"> *</span>
            </label>
            <Controller
              name="country"
              control={control}
              render={({ field: { value, onChange }, fieldState }) => (
                <>
                  <input
                    className="form-control"
                    value={value}
                    type="text"
                    placeholder="Enter Country"
                    onChange={(val) => {
                      onChange(val)
                      trigger('country')
                    }}
                  />
                  <small>{fieldState?.error?.message}</small>
                </>
              )}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-sm-12">
          <div className="form-group">
            <label>
              State <span className="text-danger"> *</span>
            </label>
            <Controller
              name="state"
              control={control}
              render={({ field: { value, onChange }, fieldState }) => (
                <>
                  <input
                    className="form-control"
                    value={value}
                    type="text"
                    placeholder="Enter State"
                    onChange={(val) => {
                      onChange(val)
                      trigger('state')
                    }}
                  />
                  <small>{fieldState?.error?.message}</small>
                </>
              )}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-sm-12">
          <div className="form-group">
            <label>
              City <span className="text-danger"> *</span>
            </label>
            <Controller
              name="city"
              control={control}
              render={({ field: { value, onChange }, fieldState }) => (
                <>
                  <input
                    className="form-control"
                    value={value}
                    type="text"
                    placeholder="Enter City"
                    onChange={(val) => {
                      onChange(val)
                      trigger('city')
                    }}
                  />
                  <small>{fieldState?.error?.message}</small>
                </>
              )}
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 col-sm-12">
          <div className="form-group input_text">
            <label>
              Region <span className="text-danger"> *</span>
            </label>
            <Controller
              name="region"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  className={`react-selectcomponent form-control ${errors?.region?.region_id ? 'error-input' : ''}`}
                  getOptionLabel={(option) => `${option.region}`}
                  getOptionValue={(option) => `${option.region_id}`}
                  options={allRegion || []}
                  isClearable
                  isSearchable={true}
                  placeholder={`Select Region`}
                  classNamePrefix="select_kanakku"
                  defaultValue={defaultRegion ? { region_id: defaultRegion.region_id, region: defaultRegion.region } : null}
                />
              )}
            />
            <small>{errors?.region?.region_id?.message || errors?.region?.message}</small>
          </div>
        </div>
      </div>
      <div className="multi_btn_div">
        <button type="button" className="btn common-outline-btn w-100" onClick={() => toggle()}>
          Cancel
        </button>
        <button type="submit" className="btn btn-primary common-field-btn w-100">
          {`Save`}
        </button>
      </div>
    </form>
  )
}

export default NewCity
